import React from "react";

function DeBurringDeDustingMachine() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">De-Burring & De-Dusting Machine</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>De-Burring & De-Dusting Machine</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE CENTERED */}
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="col-sm-6">
                      <img
                        src="assets/images/SD_PHRMA_ALL_MIX _JPGS/25.png"
                        alt="De-Burring & De-Dusting Machine"
                      />
                    </div>
                  </div>

                  <h2 className="title title-anim">De-Burring & De-Dusting Machine</h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The De-Burring & De-Dusting Machine is designed to remove 
                      loose powder, burrs, and edges from compressed tablets, 
                      ensuring a clean, smooth finish. It is widely used in 
                      pharmaceutical manufacturing for polishing and dust removal.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      Equipped with stainless steel contact parts, high 
                      efficiency polishing chamber, and adjustable vibration 
                      control, it ensures uniform de-dusting with gentle handling 
                      of tablets.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/25.png"
                            alt="De-Dusting Machine Side View"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/26.png"
                            alt="De-Dusting Machine Closeup"
                          />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-DM-750</td>
                          <td>DPM-DM-1000</td>
                        </tr>

                        <tr>
                          <td>Output Capacity</td>
                          <td>200,000 tablets/hr</td>
                          <td>300,000 tablets/hr</td>
                        </tr>

                        <tr>
                          <td>Screen Diameter</td>
                          <td>750 mm</td>
                          <td>1000 mm</td>
                        </tr>

                        <tr>
                          <td>Contact Parts</td>
                          <td>SS 316</td>
                          <td>SS 316</td>
                        </tr>

                        <tr>
                          <td>Electric Motor</td>
                          <td>0.5 HP</td>
                          <td>1 HP</td>
                        </tr>

                        <tr>
                          <td>Dimensions (L × W × H)</td>
                          <td>700 × 500 × 1000 mm</td>
                          <td>900 × 600 × 1100 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>85 kg</td>
                          <td>120 kg</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>

                      <li>
                        <a href="/mass-mixer">
                          Mass Mixer Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/colloid-mill-machine">
                          Colloid Mill Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/vibro-sifter">
                          Vibro Sifter Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default DeBurringDeDustingMachine;
